import { isEmpty } from 'lodash';

function search(alerts, searchTerm) {
  return Object.values(alerts)
    .reduce((accumulator, alert) => {
      if (alert.message.toLowerCase().includes(searchTerm.toLowerCase())) {
        // eslint-disable-next-line no-param-reassign
        accumulator[alert.id] = alert;
      }
      return accumulator;
    }, {});
}

function filter(alerts, filters) {
  return Object.values(alerts)
    .reduce((accumulator, alert) => {
      if (filters.includes(alert.type)) {
        // eslint-disable-next-line no-param-reassign
        accumulator[alert.id] = alert;
      }
      return accumulator;
    }, {});
}


export default {
  getAlertState: state => (alert) => {
    const alertState = state.alertState[alert.origin] || null;
    return alertState;
  },
  getAlerts(state) {
    const { alerts, filters, searchTerm } = state;
    if (searchTerm) {
      return search(alerts, searchTerm);
    } else if (filters.length > 0) {
      return filter(alerts, filters);
    }
    return alerts;
  },
  isListEmpty(state) {
    return isEmpty(state.alerts);
  },
  showBadge(state) {
    return state.showBadge;
  },
};
